import { chartTableFlatTransformer } from '@/utils/reports/chartTableFlatTransformer';
import { getPercentage } from './tableUtils';

const tableWithTotal = (data) => {
  if (!Array.isArray(data)) return [];

  const interviews_completed_total = data?.reduce(
    (acc, curr) => acc + curr?.interviews_completed,
    0
  );
  const total_scorecards_total = data?.reduce(
    (acc, curr) => acc + curr?.total_scorecards,
    0
  );
  const strong_yes_total = data?.reduce(
    (acc, curr) => acc + curr?.strong_yes,
    0
  );
  const strong_no_total = data?.reduce((acc, curr) => acc + curr?.strong_no, 0);
  const yes_total = data?.reduce((acc, curr) => acc + curr?.yes, 0);
  const no_total = data?.reduce((acc, curr) => acc + curr?.no, 0);
  const pending_scorecards_total = data?.reduce(
    (acc, curr) => acc + curr?.pending_scorecards,
    0
  );
  const applicants_interviewed_total = data?.reduce(
    (acc, curr) => acc + curr?.applicants_interviewed,
    0
  );
  const interviews_cancelled_total = data?.reduce(
    (acc, curr) => acc + (curr?.interviews_cancelled || 0),
    0
  );

  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      return {
        ...datum,
        interviews_completed_per: getPercentage(
          datum?.interviews_completed,
          interviews_completed_total
        ),
        interviews_completed_total,
        total_scorecards_total,
        pending_scorecards_total,
        strong_yes_total,
        strong_yes_per: getPercentage(datum?.strong_yes, strong_yes_total),
        strong_no_total,
        strong_no_per: getPercentage(datum?.strong_no, strong_no_total),
        yes_total,
        yes_per: getPercentage(datum?.yes, yes_total),
        no_total,
        no_per: getPercentage(datum?.no, no_total),
        applicants_interviewed_total,
        applicants_interviewed_per: getPercentage(
          datum?.applicants_interviewed,
          applicants_interviewed_total
        ),
        interviews_cancelled_total,
        subRows: innerFunc(datum?.subRows),
      };
    });
  }

  return innerFunc(data);
};
export const interviewsTableTransformer = ({ response, args }) => {
  // Safely extract properties from response
  const { chart = [], headers, lookups, table = [] } = response || {};
  const { dt, g1, g2 } = lookups || {}; // Lookup mappings for data transformation

  const data = g1?.length || g2?.length ? table : chart;
  const headerKey = g1?.length ? 'g1' : 'dt';

  const { group_by_1, group_by_2 } = args || {};

  // Transform raw chart data into a flat structure
  const transformedData = chartTableFlatTransformer({
    headerKey,
    headers,
    data,
    g1,
    g2,
    dt,
    g1Key: group_by_1?.id || group_by_1,
    g2Key: group_by_2?.id || group_by_2,
  });

  const tableData = tableWithTotal(transformedData);

  return tableData;
};
